export default "__VITE_ASSET__CDF7SFOc__"